import { motion } from "framer-motion";
import { Workflow } from "lucide-react";
import { PROCESS_STEPS } from "@/lib/constants";

export default function Process() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="relative py-24 md:py-32 bg-ae-gray-100"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl">
                    <div className="inline-flex items-center gap-2 text-ae-orange text-xs font-bold uppercase tracking-[0.22em]">
                        <Workflow className="h-4 w-4" /> The AE Process
                    </div>
                    <h2 className="mt-5 font-display font-extrabold text-4xl md:text-5xl lg:text-6xl text-ae-ink tracking-tight leading-[1.02]">
                        From discovery to{" "}
                        <span className="text-ae-orange">amplification</span>.
                    </h2>
                </div>

                <div className="mt-16 relative">
                    {/* Connecting line */}
                    <div className="hidden lg:block absolute top-7 left-12 right-12 h-px">
                        <div className="h-full w-full bg-gradient-to-r from-transparent via-ae-orange/40 to-transparent" />
                    </div>

                    <div className="grid lg:grid-cols-5 gap-6 lg:gap-4">
                        {PROCESS_STEPS.map((s, i) => (
                            <motion.div
                                key={s.num}
                                initial={{ opacity: 0, y: 22 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{
                                    duration: 0.7,
                                    delay: i * 0.1,
                                    ease: [0.22, 1, 0.36, 1],
                                }}
                                data-testid={`process-step-${i}`}
                                className="relative"
                            >
                                <div className="relative z-10 flex flex-col items-start">
                                    <div className="relative">
                                        <div className="h-14 w-14 rounded-full bg-white border border-black/5 shadow-ae-soft flex items-center justify-center font-display font-extrabold text-ae-orange text-sm">
                                            {s.num}
                                        </div>
                                        <div className="absolute inset-0 rounded-full bg-ae-orange/30 blur-xl -z-10" />
                                    </div>
                                    <h3 className="mt-5 font-display font-bold text-xl text-ae-ink">
                                        {s.title}
                                    </h3>
                                    <p className="mt-2 text-sm text-ae-gray-700 leading-relaxed">
                                        {s.desc}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
